export default {
  isLogged: false,
  user: null,
  refreshRequest: null,
  auth: {
  	accessToken: null,
  	refreshToken: null
  },
  surveySlug: null,
  loadingModalActive: false,
  errors: {
    active: false,
    content: []
  },
}
